import { ReactNode } from 'react'

import { BaseModal } from '../modal/base-modal/base-modal.js'
import './sheet.scss'

export interface SheetProps {
    isOpen: boolean
    title: string
    onClose: () => void
    /** Small action at the title's right edge (e.g. "Tühjenda"). */
    titleAction?: ReactNode
    children: ReactNode
    /** Full-width primary button under the content (e.g. "Näita 6 märki"); closes on click. */
    footer?: ReactNode
}

/** Bottom sheet for phones and tablets (Nele's mobile badges design, 22.10.2026). */
export const Sheet = (props: SheetProps) => (
    <BaseModal
        isOpen={props.isOpen}
        onClose={props.onClose}
        className="sheet"
        backdropClassName="sheet__backdrop"
        ariaLabel={props.title}
    >
        <div className="sheet__grip" aria-hidden="true" />
        <div className="sheet__head">
            <div className="sheet__title">{props.title}</div>
            {props.titleAction}
        </div>
        <div className="sheet__body">{props.children}</div>
        {props.footer && <div className="sheet__footer">{props.footer}</div>}
    </BaseModal>
)
